import { Component, OnInit, Input } from '@angular/core';


@Component({
  selector: 'div[boxBorderBottomItem]',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss']
})
export class WhiteBoxBorderBottomItemComponent implements OnInit {
  assetPath = '';

  @Input() iconSource: string = '';
  // ---
  @Input() title: string = '';
  // ---
  @Input() description: string = '';
  // ---
  @Input() colNumber: number = 0;
  // ---
  constructor() { }

  ngOnInit(): void {
  }

}
